import React from 'react';
import { QueueRegistry } from './queue-registry';
import { QueueRegistryContext } from './queue-registry-context';

export function useQueueRegistry(): QueueRegistry {
    const queueRegistry = React.useContext(QueueRegistryContext);
    if (!queueRegistry) {
        throw new Error('unexpectedly did not find queue registry on context');
    }
    return queueRegistry;
}
